const LOCAL_BACKEND_URL = 'http://127.0.0.1:3001/api/';

export const resolveBackendBaseUrl = (
  localMode = process.env.REACT_APP_TECO_LOCAL_MODE,
  branchName = process.env.REACT_APP_GIT_REF,
  apiUrl = process.env.REACT_APP_API_URL,
  nodeEnv = process.env.NODE_ENV,
) => {
  if (
    process.env.NODE_ENV !== 'production' &&
    nodeEnv !== 'production' &&
    localMode === 'true'
  ) {
    return LOCAL_BACKEND_URL;
  }

  const backendPreviewUrl = branchName
    ? `https://teco-backend-git-${branchName.replace(
        /\//g,
        '-',
      )}-teco1.vercel.app/api/`
    : null;

  return backendPreviewUrl ?? apiUrl;
};
